﻿'use strict'

export function useLightbox() {
    return lightbox()
}

const lightbox = () => {

    const lightbox = GLightbox({
        selector: '.glightbox',
        touchNavigation: true,
        loop: true,
        onOpen: () => { console.log('Lightbox opened') }
    });

    // Find all triggers and set up an eventlistener for them
    const lightBoxTriggers = document.querySelectorAll('[data-trigger-lightbox]');

    lightBoxTriggers.forEach(trigger => {
        trigger.addEventListener('click', triggerLightBox());
    });

    // trigger event listener callback function
    function triggerLightBox() {
        return function (event) {
            lightbox.open()
        }
    }
}